var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudioOff(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#4E4E4E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2047 24V16.2C28.2047 15.6484 28.0961 15.1023 27.885 14.5927C27.6739 14.0832 27.3645 13.6202 26.9745 13.2302C26.5845 12.8401 26.1215 12.5308 25.612 12.3197C25.1024 12.1086 24.5562 12 24.0047 12C23.4531 12 22.907 12.1086 22.3974 12.3197C21.8878 12.5308 21.4248 12.8401 21.0348 13.2302C20.6448 13.6202 20.3355 14.0832 20.1244 14.5927C19.9133 15.1023 19.8047 15.6484 19.8047 16.2V24C19.8047 24.5516 19.9133 25.0977 20.1244 25.6073C20.3355 26.1168 20.6448 26.5798 21.0348 26.9698C21.4248 27.3599 21.8878 27.6692 22.3974 27.8803C22.907 28.0914 23.4531 28.2 24.0047 28.2C24.5562 28.2 25.1024 28.0914 25.612 27.8803C26.1215 27.6692 26.5845 27.3599 26.9745 26.9698C27.3645 26.5798 27.6739 26.1168 27.885 25.6073C28.0961 25.0977 28.2047 24.5516 28.2047 24Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0031 23.4002C15.0031 28.3706 19.0327 32.4002 24.0031 32.4002M24.0031 32.4002C25.0549 32.4002 26.0647 32.2202 27.0031 31.8884M24.0031 32.4002V36.0002M33.0031 23.4002C33.0048 24.639 32.7498 25.8648 32.2543 27.0002M34.8031 34.8002L13.2031 13.2002",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioOff);
export default __webpack_public_path__ + "static/media/audio-off.7c81cdbcc419874cb9f85ae08503ca3d.svg";
export { ForwardRef as ReactComponent };